/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homecaption1Inputs */



/**
* | output |
* | --- |
* | "registration and organisation" |
*
* @param {Homecaption1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homecaption1 = /** @type {((inputs?: Homecaption1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homecaption1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("registration and organisation")
	return /** @type {LocalizedString} */ ("Bewerbung und Organisation")
});
export { homecaption1 as "homeCaption" }